module.exports = __webpack_public_path__ + "bc79e266b5d3e9b9331f02be64a22e91.svg";